import { EventOffer } from "@gp/offer";
import { formatTennisGameScore } from "@utils/offer";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

export default observer(function QuickPlayEventLiveTime(props: {
	event: EventOffer | undefined;
}) {
	const { t } = useTranslation();

	if (!props.event || !props.event?.liveStatus || !props.event.result) {
		return null;
	}

	const homeHalfTimeScore =
		props.event.result.halfTimeScore &&
		props.event.result.halfTimeScore.home
			? props.event.result.halfTimeScore.home
			: 0;
	const awayHalfTimeScore =
		props.event.result.halfTimeScore &&
		props.event.result.halfTimeScore.away
			? props.event.result.halfTimeScore.away
			: 0;

	let periods = [
		{
			periodNumber: [],
			home: [],
			away: [],
		},
	];
	if (props.event.result.scorePerPeriod) {
		// @ts-expect-error
		periods = props.event.result.scorePerPeriod.reduce(
			(
				acc: { periodNumber: number; home: number; away: number }[],
				item
			) => {
				acc.push({
					periodNumber: item.periodNumber,
					home: item.home || 0,
					away: item.away || 0,
				});

				return acc;
			},
			[]
		);
	}
	/* @ts-expect-error */ // prettier-ignore
	const isNotSnooker = props.event.result.scorePerPeriod && !props.event.result.halfTimeScore && props.event.sport?.abrv != "snooker";

	return (
		<>
			<div className="slip__match__info">
				<div className="slip__match__time">
					{props.event.matchTime?.displayTime}
				</div>

				{/* CURRENT SCORE */}
				{props.event.result.currentScore ? (
					<div className="slip__match__stats slip__match__score u-type--wgt--bold">
						{props.event.result.currentScore.home || 0} :{" "}
						{props.event.result.currentScore.away || 0}
					</div>
				) : null}

				{/* HT - HALF TIME SCORE */}
				{props.event.result.halfTimeScore && (
					<div
						className="slip__match__stats slip__match__ht"
						title={t("EVENT.DETAILS.HT")}
					>
						({homeHalfTimeScore || 0} : {awayHalfTimeScore || 0})
					</div>
				)}

				{/* SCORE PER PERIOD */}
				{isNotSnooker ? (
					<div className="slip__match__stats slip__match__periods">
						{periods.map((period, idx) => {
							return (
								<div key={idx}>
									(<strong>P{period.periodNumber}</strong>{" "}
									{period.home}:{period.away})
								</div>
							);
						})}
					</div>
				) : null}

				{/* OT - OVERTIME SCORE */}
				{props.event.result.overTimeScore && (
					<div
						className="slip__match__stats slip__match__ot"
						title={t("EVENT.DETAILS.OT_TITLE")}
					>
						({props.event.result.overTimeScore.home || 0} :{" "}
						{props.event.result.overTimeScore.away || 0})
					</div>
				)}

				{/* TBS - TIE BREAKER SCORE */}
				{props.event.result.tiebreakScore && (
					<div
						className="slip__match__stats slip__match__tbs"
						title={t("EVENT.DETAILS.TBS_TITLE")}
					>
						({props.event.result.tiebreakScore.home || 0} :{" "}
						{props.event.result.tiebreakScore.away || 0})
					</div>
				)}

				{/* GAME SCORE - TENNIS */}
				{props.event.result.currentGameScore &&
					!props.event.result.tiebreakScore && (
						<div
							className="slip__match__stats slip__match__game"
							title={t("EVENT.DETAILS.GAME_TITLE")}
						>
							(
							{formatTennisGameScore(
								props.event.result.currentGameScore.home || "0"
							)}{" "}
							:{" "}
							{formatTennisGameScore(
								props.event.result.currentGameScore.away || "0"
							)}
							)
						</div>
					)}
			</div>
		</>
	);
});
